// extracted by mini-css-extract-plugin
export default {"card":"CategoryCard_card__hON+J","active":"CategoryCard_active__g4r1g"};